(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_rooh-story-link"] && !Shopify.designMode) return;
  try {
    if (!window.roohStoryDialogReady) {
    window.roohStoryDialogReady = true;

    document.addEventListener('click', (event) => {
      const trigger = event.target.closest('[data-rooh-story-open]');
      if (trigger) {
        const dialog = document.getElementById(trigger.dataset.roohStoryOpen);
        if (dialog && typeof dialog.showModal === 'function') {
          dialog.showModal();
          const video = dialog.querySelector('video');
          if (video) {
            video.currentTime = 0;
            video.play().catch(() => {});
          }
        }
        return;
      }

      const closeButton = event.target.closest('[data-rooh-story-close]');
      if (closeButton) {
        closeButton.closest('dialog')?.close();
        return;
      }

      if (event.target.matches('.rooh-story-dialog')) {
        event.target.close();
      }
    });

    document.addEventListener('close', (event) => {
      if (event.target.matches('.rooh-story-dialog')) {
        const video = event.target.querySelector('video');
        if (video) {
          video.pause();
          video.currentTime = 0;
        }
      }
    }, true);
  }
  } catch(e) { console.error(e); }
})();

})();
